import DailyMap from './components/DailyMap';
import Map from './components/Map';

export default { DailyMap, Map };
